var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20.2693C40.001 9.4254 31.0467 0.634646 20.001 0.634647C8.95528 0.634647 0.000975205 9.4254 0.000975688 20.2694C0.000976171 31.1133 8.95528 39.9041 20.001 39.9041C31.0467 39.9041 40.001 31.1133 40.001 20.2693Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 39.9054C31.0467 39.9054 40.001 31.1146 40.001 20.2707C40.001 9.42674 31.0467 0.635986 20.001 0.635986C8.95528 0.635986 0.000976562 9.42674 0.000976562 20.2707C0.000976562 31.1146 8.95528 39.9054 20.001 39.9054Z",
    fill: "url(#paint0_radial_1032_338033)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20.2693C40.001 9.4254 31.0467 0.634646 20.001 0.634647C8.95528 0.634647 0.000975205 9.42541 0.000975688 20.2694C0.000976171 31.1133 8.95528 39.9041 20.001 39.9041C31.0467 39.9041 40.001 31.1133 40.001 20.2693Z",
    fill: "url(#paint1_linear_1032_338033)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20.2693C40.001 9.4254 31.0467 0.634646 20.001 0.634647C8.95528 0.634647 0.000975205 9.42541 0.000975688 20.2694C0.000976171 31.1133 8.95528 39.9041 20.001 39.9041C31.0467 39.9041 40.001 31.1133 40.001 20.2693Z",
    fill: "url(#paint2_radial_1032_338033)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_338033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 18.4697V16.6698C27.3333 14.7605 26.5607 12.9293 25.1854 11.5791C23.8102 10.229 21.9449 9.47046 20 9.47046C18.0551 9.47046 16.1898 10.229 14.8145 11.5791C13.4393 12.9293 12.6667 14.7605 12.6667 16.6698V18.4697C12.6442 19.0186 12.5066 19.5571 12.2626 20.0515C12.0186 20.5459 11.6734 20.9856 11.2486 21.3432C10.4852 21.9818 10.007 22.8886 9.91666 23.8692C9.91666 26.119 13.686 27.4689 20 27.4689C26.314 27.4689 30.0833 26.119 30.0833 23.8692C29.993 22.8886 29.5148 21.9818 28.7514 21.3432C28.3266 20.9856 27.9814 20.5459 27.7374 20.0515C27.4934 19.5571 27.3558 19.0186 27.3333 18.4697Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3829 29.1787C17.5576 29.7258 17.9057 30.2039 18.3764 30.5434C18.8471 30.8828 19.4159 31.0658 20 31.0658C20.5841 31.0658 21.1529 30.8828 21.6236 30.5434C22.0943 30.2039 22.4424 29.7258 22.6171 29.1787C21.7976 29.2381 20.9267 29.2687 20 29.2687C19.0732 29.2687 18.2024 29.2399 17.3829 29.1787Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1032_338033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 30.6348C16.4787 30.6348 27 20.1135 27 7.13476C27 5.24511 26.777 3.40755 26.3558 1.64697C34.2857 4.25434 40 11.6068 40 20.2695C40 31.1134 31.0457 39.9042 20 39.9042C12.8278 39.9042 6.5374 36.1978 3.00755 30.6297C3.1713 30.6331 3.33545 30.6348 3.5 30.6348Z",
    fill: "url(#paint3_linear_1032_338033)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1032_338033",
    x: 1.67422,
    y: 0.313639,
    width: 39.6591,
    height: 40.9237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1032_338033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1032_338033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1032_338033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9271 0.634646) rotate(135.528) scale(34.6692 34.6633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_338033",
    x1: 18.3343,
    y1: -2.6378,
    x2: 0.46041,
    y2: 24.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1032_338033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 9.96113) rotate(143.795) scale(47.0919 38.6618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1032_338033",
    x1: 21.5088,
    y1: 39.9041,
    x2: 26.367,
    y2: 12.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_338033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.5982,
    fill: "white",
    transform: "translate(9 9.47046)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.135f7070.svg";
export { ForwardRef as ReactComponent };